import { render } from "./Profile.vue?vue&type=template&id=ef346688&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=ef346688&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ef346688"

export default script